import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwareDisplayNameAttributePropertyValues =
    AttributePropertyValues
    & {
        displayName: string;
    };

export type ClientAwareDisplayNameAttributeProperties = {
    [name in keyof ClientAwareDisplayNameAttributePropertyValues]?: ClientAwareDisplayNameAttributePropertyValues[name];
};

export interface IClientAwareDisplayNameAttribute extends IAttribute, ClientAwareDisplayNameAttributeProperties
{
}

export class ClientAwareDisplayNameAttribute extends Attribute implements IClientAwareDisplayNameAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwareDisplayNameAttribute";
    public static override className = "ClientAwareDisplayNameAttribute";

    public displayName?: string;

    constructor(propertyValues?: Partial<ClientAwareDisplayNameAttributePropertyValues>)
    {
        super(propertyValues);

        this.displayName = propertyValues?.displayName;
    }
}